// extracted by mini-css-extract-plugin
export default {"timerContainer":"timer_timerContainer__xanpY","timerBox":"timer_timerBox__zECgO","timerImage":"timer_timerImage__H-qAs"};